/**
 * Content.js
 *
 * Dynamic view matching container state.
 *
 * Copyright (c) apploft. GmbH
 */

import React from 'react';
import {EndPointForm, List, stringMatching} from 'apploft-cloud-forms';

import {
  ready,
  presentingList,
  presentingForm,
  fetchingItems,
  submittingForm,
  fetchingItem,
  presentingEditingForm,
} from './ContentStateSymbol';

import {submitForm, editItem, submitEditForm} from './ContentEventSymbol';

import Spinner from '../../Spinner/Spinner';

import './EndPointForm.css';
import './Content.css';

function createList({section, api, items}, dispatch) {
  return (
    <List
      items={items}
      onItemClick={item => {
        dispatch({event: editItem, payload: {section, api, item, dispatch}});
      }}
    />
  );
}

function isItem(item) {
  return typeof item === 'object';
}

function createEndPointForm({widgetProps, item}, dispatch, strings) {
  return (
    <EndPointForm
      widgetProps={widgetProps}
      item={item}
      strings={strings}
      onSubmit={formData => {
        if (isItem(item)) {
          dispatch({
            event: submitEditForm,
            payload: {item, formData, dispatch},
          });

          return;
        }

        dispatch({event: submitForm, payload: {formData, dispatch}});
      }}
    />
  );
}

function createHome({message}, strings) {
  return (
    <div className="centered">
      <p>{stringMatching(strings, message)}</p>
    </div>
  );
}

function Content({state, data, dispatch, strings}) {
  switch (state) {
    case presentingList:
      return createList(data, dispatch);

    case presentingForm:
    case presentingEditingForm:
      return createEndPointForm(data, dispatch, strings);

    case ready:
      return createHome(data, strings);

    case fetchingItems:
    case submittingForm:
    case fetchingItem:
      return <Spinner />;

    default:
      throw new Error(
        `no matching view for state: ${state ? state.toString() : 'none'}`,
      );
  }
}

export default Content;
